import { render, staticRenderFns } from "./repairManagement.vue?vue&type=template&id=5c4f5237&scoped=true"
import script from "./repairManagement.vue?vue&type=script&lang=js"
export * from "./repairManagement.vue?vue&type=script&lang=js"
import style0 from "./repairManagement.vue?vue&type=style&index=0&id=5c4f5237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f5237",
  null
  
)

export default component.exports